// extracted by mini-css-extract-plugin
export var addButton = "_cr-4";
export var contentBlockImage = "_cr-i";
export var contentBlockWidgetPreview = "_cr-g";
export var fulfillmentCutoffWidgetPreview = "_cr-9";
export var imageBackdrop = "_cr-6";
export var imageIcon = "_cr-8";
export var lowProfileImageContainer = "_cr-b";
export var lowProfileImageIcon = "_cr-f";
export var lowProfileImageIconContainer = "_cr-e";
export var lowProfileImagePlaceholder = "_cr-d";
export var lowProfileProductImage = "_cr-c";
export var lowProfileProductUpsellWidgetPreview = "_cr-a";
export var productCard = "_cr-5";
export var productImage = "_cr-7";
export var productReviewsWidgetPreview = "_cr-h";
export var progressBar = "_cr-1";
export var progressBarFill = "_cr-2";
export var progressBarTrack = "_cr-3";
export var shippingOptionWidgetPreview = "_cr-j";
export var shippingUpsellProgressBar = "_cr-k";
export var thresholdUpsellWidgetPreview = "_cr-0";